export default __webpack_public_path__ + "static/media/desingingPages.1d973535.jpeg";